(() => {

    const ADVANCED_ANALYTICS = () => {
        if( window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true ) return;
        
        if( window.__digiAdvancedAnalyticsStep2of2 ) return;
        window.__digiAdvancedAnalyticsStep2of2 = true;

        console.log('~~ ADVANCED ANALYTICS - STEP 2 of 2 ~~');
    
        // STEP 2 of 2
            // - Listings
            // - Cart
            // - Checkout
    
        const storageKeys = {
            itemsListingSource: 'digi__items-listing-source',       // localStorage
            itemsAddedToCartData: 'digi__items-added-to-cart-data'  // localStorage
        };
    
        // SOURCE
        const getFromLocalStorage = (key, fallback = null) => {
            if( !key ) return fallback;
    
            const raw = localStorage.getItem(key);
            if( raw === null ) return fallback;
    
            try {
                return JSON.parse(raw);
            }  catch (e) {
                return fallback;
            };
        };
    
        const setToLocalStorage = (key, value) => {
            if( !key ) return;
    
            localStorage.setItem(key, JSON.stringify(value ?? null));
        };
    
        const setListingSource = (data) => {
            if( !data?.itemId ) return;
    
            const stored = getFromLocalStorage(storageKeys.itemsListingSource, {}) || {};
            stored[String(data.itemId)] = {
                listing: String(data.listingName || ''),
                index: Number.isFinite(parseInt(data.index)) ? parseInt(data.index) : null
            };
    
    
            setToLocalStorage(storageKeys.itemsListingSource, stored);
        };
    
        // -- HELPERS
        const isEmptyCart = () => {
            const cartCount = document.querySelector("header [id^='cart-icon'] span[aria-hidden]");
            let status = true;
    
            if( cartCount ) {
                const cartCountValue = parseInt(cartCount.textContent.trim());
    
                status = cartCountValue > 0 ? false : true;
            } else {
                status = true;
            };
            
            return status;
        };
    
    
        const waitForElement = (selector, callback, timeout) => {
            const t_out = timeout ? timeout : 10000;
            const element = document.querySelector(selector);
    
            if( element ) {
                callback(element);
                return;
            };
    
            const observer = new MutationObserver(() => {
                const el = document.querySelector(selector);
                if( !el ) return;
    
                observer.disconnect();
                clearTimeout(timer);
                callback(el);
            });
    
            observer.observe(document.documentElement, { childList: true, subtree: true });
    
            const timer = setTimeout(() => observer.disconnect(), t_out);
        };
    
        const getMetaContent = (property) => {
            return document.head.querySelector(`[property = "${property}"]`)?.content || null;
        };
    
        const returnItemData = (item, customData, config) => {
            let itemElement = {};
    
            if( config?.recoType === 'recommended-accessories' ) {
                itemElement = {
                    id: item.querySelector('input[type="hidden"][name="product-id"][value]')?.value ?? null,
                    title: item.querySelector('.accessory-meta a.full-unstyled-link[href]')?.textContent?.trim() ?? '',
                    price: item.querySelector('span.price-item--regular')?.textContent ?? null
                }
            } else if( config?.recoType === 'related_products' ) {
                itemElement = {
                    id: null,
                    title: item.querySelector('.related-title')?.textContent?.trim() ?? '',
                    price: null
                };
            } else if( config?.recoType === 'standard' ) {
                let id = item.querySelector('input[type="hidden"][name="product-id"][value]')?.value ?? null;

                if( !id ) {
                    id = item.querySelector('a[id^="CardLink-template"]')?.id?.split('-').pop() ?? null;
                };
    
                itemElement = {
                    id: id || null,
                    title: item.querySelector('.card__heading a')?.textContent?.trim() ?? '',
                    price: item.querySelector('.card-information .price span.price-item--regular')?.textContent ?? null
                };
            } else if( config?.isCartPage ) {
                itemElement = {
                    id: item.querySelector('[id^="delivery-estimate-"]')?.id?.replace('delivery-estimate-','') ?? null,
                    title: item.querySelector('.cart-item__details a.cart-item__name')?.textContent ?? '',
                    price: item.querySelector('.cart-item__price-wrapper .price--end')?.textContent ?? null,
                    quantity: parseInt(item.querySelector('input.quantity__input')?.value) || 1
                };
    
                const parseTextToKey = (text) => {
                    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ł/g, "l").replace(/Ł/g, "L").toLowerCase().trim().replaceAll(' ', '-').replaceAll(':', '');
                };
    
                const configOptions = Array.from(item.querySelectorAll('.cart-item__details dl .product-option'));
                if( configOptions?.length ) {
                    configOptions.forEach(option => {
                        const optionData = {
                            key: option.querySelector('dt')?.textContent ?? null,
                            value: option.querySelector('dd')?.textContent ?? null
                        };
                        if( !optionData.key || !optionData.value ) return;
    
                        customData[parseTextToKey(optionData.key)] = optionData.value.trim();
                    });
                };
            } else {
                const wishlistObj = item.querySelector('[data-wishlist]').dataset.wishlist.trim().replaceAll(`'`,`"`);
                if( !wishlistObj ) return;

                const wishlistData = JSON.parse(wishlistObj);
                customData['item_category5'] = wishlistData?.item?.id.toString() ?? null;
                

                itemElement = {
                    id: item.querySelector('.card__information .card__heading a[href]')?.id ?? null,
                    title: item.querySelector('.card__information .card__heading a[href]')?.textContent?.trim() ?? '',
                    price: item.querySelector('.card-information .price .price-item--regular')?.textContent ?? null
                };

    
                // ID
                const itemIDFullString = itemElement?.id?.split('__')?.pop()?.split('-') ?? [];
                if( itemIDFullString[0] === 'product' && itemIDFullString[1] === 'grid' && itemIDFullString[2] ) {
                    itemElement.id = itemIDFullString[2];
                };
            };
    
            // PRICE
            itemElement.price = parsePrice(itemElement.price) / (itemElement?.quantity || 1);
    
            const data = {
                item_id: itemElement.id ? String(itemElement.id) : null,
                item_name: itemElement.title,
                item_category: '',
                item_brand: 'MittoHome',
                quantity: itemElement?.quantity || 1,
                currency: 'PLN',
                price: itemElement.price,
                ...customData
            };
    
            return data;
        };
    
        const parsePrice = (priceString) => {
            if( !priceString ) return 0;
            const normalized = String(priceString).toLowerCase().replace('od', '').replace('pln','').replace('zł', '').replaceAll(',','.').replaceAll(' ','').trim();
            const price = parseFloat(normalized);
            return Number.isFinite(price) ? price : 0;
        };
    
    
    
        // -- DataLayer Push (or Console.log DEBUG)
        const dataLayer_Push = (data) => {
            data.event = 'digi__' + data.event;
    
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
            //console.log(data);
        };
    
        // -- Cart Attributes Push
        const cartAttributes_Push = async (value) => {
            const res = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        'digi-purchase-data': JSON.stringify(value)
                    }
                })
            });
    
            if (!res.ok) throw new Error('Cart update failed');
            return res.json();
        };
    
    
        // -- EVENTS
        const viewItemList_Event = (data) => {
            if( !data?.items?.length ) return;
    
            const eventData = {
                event: 'view_item_list',
                item_list_name: data.listingName,
                ecommerce: {
                    items: data.items
                }
            };
    
            data.page ? eventData.page = data.page : null;
            data.item_list_id ? eventData.item_list_id = data.item_list_id : null;
    
            dataLayer_Push(eventData);
        };
    
        const viewItem_Event = (data) => {
            if( !data?.items?.length ) return;
    
            const eventData = {
                event: 'view_item',
                item_list_name: data.listingName,
                ecommerce: {
                    items: data.items
                }
            };
    
            data.item_list_id ? eventData.item_list_id = data.item_list_id : null;
    
            dataLayer_Push(eventData);
        };
    
        const selectItemList_Event = (data) => {
            if( !data?.items?.length ) return;
    
            const eventData = {
                event: 'select_item',
                item_list_name: data.listingName,
                ecommerce: {
                    items: data.items
                }
            };
    
            data.page ? eventData.page = data.page : null;
            data.item_list_id ? eventData.item_list_id = data.item_list_id : null;
    
            setListingSource({
                itemId: eventData.ecommerce.items[0].item_id,
                index: eventData.ecommerce.items[0].index,
                listingName: eventData.item_list_name
            });
            dataLayer_Push(eventData);
        };
    
        const addToCart_Event = (data) => {
            if( !data?.items?.length ) return;
    
            const eventData = {
                event: 'add_to_cart',
                item_list_name: data.listingName,
                ecommerce: {
                    items: data.items
                }
            };
    
            data.item_list_id ? eventData.item_list_id = data.item_list_id : null;
    
            console.log(data);
            if( data.isToSave ) {
                let variantIdAsKey = data?.variantID;
                if( !variantIdAsKey ) return;
    
                variantIdAsKey = String(variantIdAsKey);
    
                if( isEmptyCart() ) {
                    localStorage.removeItem(storageKeys.itemsAddedToCartData);
                };
    
                setTimeout(() => {
                    const orderMap = getFromLocalStorage(storageKeys.itemsAddedToCartData) || {};
                    if( !orderMap[variantIdAsKey] ) {
                        orderMap[variantIdAsKey] = {
                            itemData: eventData.ecommerce.items,
                            listingName: eventData.item_list_name,
                            order: new Date().getTime()
                        };
                        setToLocalStorage(storageKeys.itemsAddedToCartData, orderMap);
                    };
                }, 300);
            };
    
            dataLayer_Push(eventData);
        };
    
        const viewCart_Event = (data) => {
            if( !data?.items?.length ) return;
    
            const eventData = {
                event: 'view_cart',
                ecommerce: {
                    currency: 'PLN',
                    value: data.totalValue,
                    items: data.items
                }
            };
    
            dataLayer_Push(eventData);
            cartAttributes_Push(eventData.ecommerce);
        };
    
    
        // -- LISTINGS
        const __categoryListing_Init = () => {
            const uniqueSelector = document.querySelector('body[data-tpl="collection"]');
            if( !uniqueSelector ) return;
    
            const sectionTitleBox = uniqueSelector.querySelector('.collection-hero__title');
            if( !sectionTitleBox ) return;
    
            const sectionTitle = sectionTitleBox.textContent.split(':').pop().trim().toLowerCase().replaceAll(' ','_');
    
            const productsListContent = uniqueSelector.querySelector('ul#product-grid');
            if( !productsListContent ) return;
    
            const productsElements = Array.from(productsListContent.querySelectorAll('li.grid__item'));
            if( !productsElements ) return;
    
    
            const indexByElement = new Map(productsElements.map((el, i) => [el, i]));
    
            const groupIntoRows = (elements) => {
                const rows = [];
                let currentRow = [];
                let currentTop = null;
                const tolerancePx = 10;
    
                elements.forEach(el => {
                    const top = el.getBoundingClientRect().top;
    
                    if( currentTop === null ) {
                        currentTop = top;
                        currentRow = [el];
                        return;
                    };
    
                    if( Math.abs(top - currentTop) <= tolerancePx ) {
                        currentRow.push(el);
                    } else {
                        rows.push(currentRow);
                        currentTop = top;
                        currentRow = [el];
                    };
                });
    
                if( currentRow.length ) rows.push(currentRow);
                return rows;
            };
    
            const rows = groupIntoRows(productsElements);
            
            const itemMetaData = {};

            document.addEventListener('click', (event) => {
                const aHref = event.target.closest('#product-grid .grid__item .product-card-wrapper a[id^="CardLink"]:not(.digi-clicked)');
                if( !aHref ) return;

                const digiKey = aHref.dataset.digiKey;
                if( !digiKey ) return;
                
                event.preventDefault();

                if( !itemMetaData[digiKey] ) return;

                aHref.classList.add('digi-clicked');

                selectItemList_Event({
                    items: itemMetaData[digiKey].items,
                    listingName: itemMetaData[digiKey].listingName,
                    page: itemMetaData[digiKey].page
                });

                setTimeout(() => {
                    window.location.href = aHref.href;
                }, 150);
            });

            const io = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if( !entry.isIntersecting ) return;
    
                    const target = entry.target;
                    const rowIndex = Number(target.dataset.__rowIndex);
                    if( !Number.isFinite(rowIndex) ) return;
    
                    const rowEls = rows[rowIndex] || [];
                    const itemsToSend = [];
    
                    rowEls.forEach(item => {
                        const customData = {
                            index: indexByElement.get(item),
                            item_list_name: sectionTitle
                        };
    
                        const itemData = returnItemData(item, customData);
                        const itemId = itemData.item_id;
                        if( !itemId ) return;
    
                        itemsToSend.push(itemData);

                        const aElements = item.querySelectorAll('a[id^="CardLink"]');
                        if( !aElements?.length ) return;

                        aElements.forEach(a => {
                            a.dataset.digiKey = itemId;
                        });

                        itemMetaData[itemId] = {
                            items: [itemData],
                            listingName: sectionTitle,
                            page: parseInt(new URLSearchParams(window.location.search).get('page')) || 1
                        };
                        

                        // a.addEventListener('click', function(event) {
                            
                        //     if (window.__digiPointerMoved) return; // swipe => ignoruj

                        //     if (this.classList.contains('digi-click-init')) return;

                        //     const link = this.href;
                        //     if (!link) return;

                        //     // nie psuj UX: ctrl/cmd/mbutton
                        //     if (event.button && event.button !== 0) return;
                        //     if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

                        //     event.preventDefault();
                        //     event.stopPropagation();
                        //     event.stopImmediatePropagation?.();

                        //     this.classList.add('digi-click-init');

                        //     selectItemList_Event({
                        //         items: [itemData],
                        //         listingName: sectionTitle,
                        //         page: parseInt(new URLSearchParams(window.location.search).get('page')) || 1
                        //     });

                        //     setTimeout(() => { window.location.href = link; }, 500);
                        // }, true); // CAPTURE

                    });
    
    
                    if( itemsToSend.length ) {
                        viewItemList_Event({
                            listingName: sectionTitle,
                            items: itemsToSend,
                            page: parseInt(new URLSearchParams(window.location.search).get('page')) || 1
                        });
                    };
    
                    io.unobserve(target);
                });
            }, { threshold: 0.25, rootMargin: "0px 0px -10% 0px" });
    
            rows.forEach((rowEls, idx) => {
                const first = rowEls[0];
                if( !first ) return;
                first.dataset.__rowIndex = String(idx);
                io.observe(first);
            });
        };
    
        const __recoListing_Init = (configData) => {
            const __recoListing = (uniqueSel) => {
                const uniqueSelector = uniqueSel.closest(configData.uniqueSelector);
                if( !uniqueSelector ) return;
                
                const productsListSelector = uniqueSelector.querySelector(configData.productsListSelector);
                if( !productsListSelector ) return;
        
                const productsElements = Array.from(productsListSelector.querySelectorAll(configData.productSelector));
                if( !productsElements.length ) return;
        
                let productPage_ID = null;
                const dlData = dataLayer.find(obj => obj?.['1'] === 'view_item')?.[2];
        
                if( dlData ) {
                    productPage_ID = dlData['ecomm_prodid']?.[0] ?? null;
    
                    const newIDversion = String(productPage_ID)?.replace('shopify_PL_', '')?.split('_') || null;
                    if( !newIDversion?.[0] ) return;
    
                    productPage_ID = newIDversion?.[0];
                };

                if( !productPage_ID ) {
                    productPage_ID = document.querySelector('body[data-tpl^="product"] product-info form[id^="product-form-installment-template"] input[name = "product-id"]')?.value ?? null;
                };
                
                const productTitle = document.querySelector('product-info .product__title h1')?.textContent.trim().toLowerCase().replaceAll(' ','_') ?? '';
                const productPage_Name = productTitle ? `__${productTitle}` : '';
                const listingName = configData.listingName + productPage_Name;
                const indexByElement = new Map(productsElements.map((el, i) => [el, i]));
                let itemsToSend = [];
        
                let debounceTimer = null;
                const debounce = (fn, delay) => {
                    clearTimeout(debounceTimer);
                    debounceTimer = setTimeout(fn, delay);
                };
        
                const flushViewItemList = () => {
                    if( !itemsToSend.length ) return;
        
                    viewItemList_Event({
                        listingName: listingName,
                        items: itemsToSend,
                        item_list_id: productPage_ID
                    });
        
                    itemsToSend = [];
                };
        
                const io = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if( !entry.isIntersecting ) return;
    
                        
                        const item = entry.target;
                        let variantID = null;

                        const wishlistObj = item.querySelector('[data-wishlist]')?.dataset?.wishlist?.trim()?.replaceAll(`'`,`"`) ?? null;
                        if( wishlistObj ) {
                            const wishlistData = JSON.parse(wishlistObj);
                            variantID = wishlistData?.item?.id.toString() ?? null;
                        } else {
                            variantID = item.querySelector('input.product-variant-id')?.value ?? null;
                        };
                        
                        const customData = {
                            index: indexByElement.get(item),
                            item_list_name: listingName,
                            item_list_id: productPage_ID,
                            item_category5: variantID
                        };
        
                        const itemData = returnItemData(item, customData, { recoType: configData.recoType });
                        itemsToSend.push(itemData);
                        
                        debounce(() => flushViewItemList(), configData.flushDelayMs || 120);
        
                        const linkTargets = ['a[id^="CardLink"][href]', 'a.related-product[href]', 'a[href]:not([href=""])'];
                        linkTargets.forEach(aHref => {
                            let aHrefElements = [];
                            
                            if( item.querySelectorAll(aHref).length ) {
                                aHrefElements = Array.from(item.querySelectorAll(aHref));
                            } else if( item.matches(aHref) ) {
                                aHrefElements = [item];
                            } else {
                                return;
                            };
        
                            if( !aHrefElements.length ) return;
        
                            aHrefElements.forEach(element => {
                                element.addEventListener('click', function(event) {
                                    if( this.classList.contains('digi-click-init') ) return;
        
                                    const link = this.href;
                                    if( !link ) return;
                                    
                                    event.preventDefault();
                                    this.classList.add('digi-click-init');
                                    
                                    selectItemList_Event({
                                        items: [itemData],
                                        listingName: listingName,
                                        item_list_id: productPage_ID
                                    });
                                    
                                    setTimeout(() => {
                                        window.location.href = link;
                                    }, 150);
                                });
                            });
                        });
    
                        // Add To Cart
                        const addToCartBtn = item.querySelector('button.quick-add__submit');
                        addToCartBtn?.addEventListener('click', function() {
                            addToCart_Event({
                                listingName: listingName,
                                items: [itemData],
                                item_list_id: productPage_ID,
                                isToSave: true,
                                variantID: variantID
                            });
                        });
        
                        io.unobserve(item);
                    });
                }, { threshold: 0.25, rootMargin: "0px 0px -10% 0px" });
        
                productsElements.forEach(el => io.observe(el));
            };
    
            waitForElement(configData.uniqueSelector + ' ' + configData.productSelector, (waitingElement) => __recoListing(waitingElement), configData?.timeout || null);
        };
    
        const __productPageListing_Init = () => {
            const uniqueSelector = document.querySelector('body[data-tpl^="product."] product-info');
            if( !uniqueSelector ) return;
            
            const dlData = dataLayer.find(obj => obj?.['1'] === 'view_item')?.[2];
            if( !dlData ) return;
    
            
            const itemData = {
                id: dlData['ecomm_prodid']?.[0] ?? null,
                title: uniqueSelector.querySelector('.product__title h1')?.textContent?.trim() ?? '',
                price: getMetaContent('og:price:amount')
            };
    
            if( !itemData.id ) return;
    
            const newIDversion = String(itemData.id)?.replace('shopify_PL_', '')?.split('_')?.[0] || null;
            if( !newIDversion ) return;
    
            itemData.id = newIDversion;
    
            const getVariantID = () => {
                let varID = uniqueSelector.querySelector('form[id^="product-form-installment-template"] input[name="id"]')?.value ?? null;

                if( !varID ) {
                    varID = new URLSearchParams(window.location.search)?.get('variant') ?? null;
                };
                
                return varID;
            };
    
            let listingName = '';
            let index = null;
            const stored = getFromLocalStorage(storageKeys.itemsListingSource) || {};
    
            if( stored ) {
                listingName = stored?.[itemData.id]?.listing || '';
                index = stored?.[itemData.id]?.index ?? null;
            };
    
            const productData = {
                item_id: itemData.id,
                item_category5: getVariantID(),
                item_name: itemData.title,
                item_category: '',
                item_brand: 'MittoHome',
                quantity: 1,
                currency: 'PLN',
                price: parsePrice(itemData.price),
                item_list_name: listingName,
                index: index,
                item_list_id: itemData.id
            };
    
            viewItem_Event({
                listingName: listingName,
                items: [productData],
                item_list_id: itemData.id
            });
    
    
            // Add To Cart
            const addToCartBtn = uniqueSelector.querySelector('product-form .product-form__buttons button[name="add"]');
            addToCartBtn?.addEventListener('click', function() {
                setTimeout(() => {
                    const configData = window.__digi_config ?? null;
    
                    let newProductData = productData;
        
                    if( configData?.used && configData?.productData?.[0] ) {
                        newProductData.item_category = configData.productData[0].category;
                        newProductData.item_variant = configData.productData[0].variant;
                        newProductData.price = parsePrice(uniqueSelector.querySelector('div[id^="price-template"] span.price-item--regular')?.textContent ?? ''),
                        newProductData.konfigurator = 'tak';
                        newProductData.item_category5 = getVariantID();
        
                        delete configData.productData[0].id;
                        delete configData.productData[0].name;
                        delete configData.productData[0].brand;
                        delete configData.productData[0].category;
                        delete configData.productData[0].price;
                        delete configData.productData[0].variant;
        
                        newProductData = { ...newProductData, ...configData.productData[0] };
                    };
        
                    addToCart_Event({
                        listingName: listingName,
                        items: [newProductData],
                        item_list_id: itemData.id,
                        isToSave: true,
                        variantID: new URLSearchParams(window.location.search).get('variant') || itemData.id
                    });
                }, 500);
            });
        };
    
        const __cartPageListing_Init = () => {
            const uniqueSelector = document.querySelector('body[data-tpl = "cart"]');
            if( !uniqueSelector ) return;
    
            let debounceTimer = null;
            const debounce = (fn, delay) => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(fn, delay);
            };
    
            const observer = new MutationObserver(() => {
                debounce(() => __cartPageListing(), 100);
            });
    
            observer.observe(uniqueSelector.querySelector('cart-items .js-contents'), { childList: true, subtree: false });
    
    
            const __cartPageListing = () => {
                const productsContent = uniqueSelector.querySelector('cart-items .cart-items tbody');
                if( !productsContent ) return;
        
                const products = productsContent.querySelectorAll('tr.cart-item');
                if( !products?.length ) return;
        
                const stored = getFromLocalStorage(storageKeys.itemsAddedToCartData) || {};
        
                const localOrderIndexMap = Object.entries(stored).sort(([, a], [, b]) => (a.order ?? 0) - (b.order ?? 0)).reduce((acc, [varId], idx) => {
                    acc[varId] = idx + 1;
                    return acc;
                }, {});
        
        
                const mergedData = [];
                let totalValue = uniqueSelector.querySelector('.totals.totals--before-discount p.totals__total-value')?.textContent ?? '';
                totalValue = parsePrice(totalValue);
        
                products.forEach(item => {
                    const itemData = returnItemData(item, {}, { isCartPage: true });
                    let finalItemData = {};
                    
                    const variantIdAsKey = String(item.querySelector('input[data-quantity-variant-id]')?.dataset.quantityVariantId) || '';
                    let storedItem = stored[variantIdAsKey];
        
                    if( !storedItem ) {
                        storedItem = stored[itemData.item_id];
                    };

                    console.log(variantIdAsKey);
                    console.log(storedItem);
                    if( storedItem ) {
                        storedItem.itemData[0].order = localOrderIndexMap[variantIdAsKey] ?? null;
                        finalItemData = storedItem.itemData[0];
                    } else {
                        finalItemData = itemData;
                    };
        
                    mergedData.push(finalItemData);
                });
    
                viewCart_Event({
                    items: mergedData,
                    totalValue: totalValue
                });
            };
    
            __cartPageListing();
    
        };
    
    
        // -- GLOBAL INIT
        const __globalEvents_Init = () => {
            __categoryListing_Init();
    
            // Product Page
            __productPageListing_Init();
            __recoListing_Init({
                uniqueSelector: '.related-products-box',
                productsListSelector: '.embla__container',
                productSelector: '.related-product',
                listingName: 'inne_modele_z_kolekcji',
                recoType: 'related_products'
            });
            __recoListing_Init({
                uniqueSelector: '.recommended-accessories-box',
                productsListSelector: '.embla__container',
                productSelector: '.accessory-wrap',
                listingName: 'polecane_produkty_do_zestawienia',
                recoType: 'recommended-accessories'
            });
            __recoListing_Init({
                uniqueSelector: 'section[id] .collection',
                productsListSelector: 'slider-component ul',
                productSelector: '.card',
                listingName: 'zobacz_rowniez',
                recoType: 'standard',
                timeout: 120000
            });
    
    
            // Cart
            __cartPageListing_Init();
            __recoListing_Init({
                uniqueSelector: 'body[data-tpl = "cart"] cart-recommendations.related-products',
                productsListSelector: 'slider-component ul',
                productSelector: '.card',
                listingName: 'moga_ci_sie_spodobac',
                recoType: 'standard'
            });
            __recoListing_Init({
                uniqueSelector: 'body[data-tpl = "cart"] .bestsellers',
                productsListSelector: 'slider-component ul',
                productSelector: '.card',
                listingName: 'inni_kupili_takze',
                recoType: 'standard'
            });
        };

        __globalEvents_Init();
    };


    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                ADVANCED_ANALYTICS();
            }, 1000);
        }, { once: true });
    } else {
        setTimeout(() => {
            ADVANCED_ANALYTICS();
        }, 1000);
    };

})();